<template>
  <div class="form-container">
    <a-form-model ref="form" :model="formData" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
      <form-title text="软件基本信息" />
      <a-form-model-item label="软件全称" prop="fullName.data">
        <a-input v-model="formData.fullName.data" @focus="onFocus('fullName')" @blur="onBlur('fullName')" :disabled="isDisabled('fullName')" placeholder="命名规范：品牌+产品用途与功能+软件/系统" />
        <div class="tip cr-fs-sm cr-text-grey-1">
          <svg-icon class="tip-icon" icon-class="tip"></svg-icon>
          <span>IOS与安卓需以两份软件名称各自申请，以软件/平台/系统/小程序/APP结尾；申请材料中的软件名称需与此名称一致。</span>
        </div>
      </a-form-model-item>

      <a-form-model-item label="软件简称" prop="shortName.data">
        <a-input v-model="formData.shortName.data" @focus="onFocus('shortName')" @blur="onBlur('shortName')" :disabled="isDisabled('shortName')" placeholder="请输入软件简称，简称文字内容需短与全称" />
      </a-form-model-item>

      <a-form-model-item label="版本号" prop="versionNo.data">
        <a-input v-model="formData.versionNo.data" @focus="onFocus('versionNo')" @blur="onBlur('versionNo')" :disabled="isDisabled('versionNo')" placeholder="请输入版本号，如：V1.0" />
      </a-form-model-item>

      <a-form-model-item label="软件分类" prop="category.data">
        <a-radio-group v-model="formData.category.data" @change="onBlur('category')">
          <a-radio-button value="应用软件"> 应用软件 </a-radio-button>
          <a-radio-button value="嵌入式软件"> 嵌入式软件 </a-radio-button>
          <a-radio-button value="中间件"> 中间件 </a-radio-button>
          <a-radio-button value="操作系统"> 操作系统 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="开发完成日期" prop="completionDate.data">
        <a-date-picker valueFormat="YYYY-MM-DD" class="date-picker" style="width: 370px" v-model="formData.completionDate.data" @focus="onFocus('completionDate')" @change="onBlur('completionDate')" :disabled="isDisabled('completionDate')" placeholder="请选择软件开发完成的日期" :getCalendarContainer="(triggerNode) => triggerNode.parentNode" />
        <div class="tip cr-fs-sm cr-text-grey-1">
          <svg-icon class="tip-icon" icon-class="tip"></svg-icon>
          <span>不能超过填报日期，且公司成立3个月以后的日期；如公司成立不足3个月，需额外提供前期开发说明。</span>
        </div>
      </a-form-model-item>

      <a-form-model-item label="发表状态" prop="publishState.data">
        <a-radio-group v-model="formData.publishState.data" @change="onBlur('publishState')">
          <a-radio-button value="已发表"> 已发表 </a-radio-button>
          <a-radio-button value="未发表"> 未发表 </a-radio-button>
        </a-radio-group>
        <div class="tip cr-fs-sm cr-text-grey-1">
          <svg-icon class="tip-icon" icon-class="tip"></svg-icon>
          <span>第一次销售、公开、展示都算发表</span>
        </div>
      </a-form-model-item>
      <a-form-model-item label="首次发表日期" prop="firstPublishDate.data" v-if="formData.publishState.data == '已发表'">
        <a-date-picker valueFormat="YYYY-MM-DD" style="width: 370px" v-model="formData.firstPublishDate.data" @focus="onFocus('firstPublishDate')" @change="onBlur('firstPublishDate')" :disabled="isDisabled('firstPublishDate')" placeholder="请选择首次发表日期" :getCalendarContainer="(triggerNode) => triggerNode.parentNode" />
      </a-form-model-item>
      <a-form-model-item label="首次发表地址" prop="firstPublishAddress.data" v-if="formData.publishState.data == '已发表'">
        <a-select class="address-select" default-value="中国" disabled />

        <a-select class="address-select" v-model="provinceObj" placeholder="省" @change="onProvinceChange" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in provinceList" :key="key" :label="item">{{ item }}</a-select-option>
        </a-select>
        <a-select class="address-select" v-model="cityObj" placeholder="市" @change="onCityChange" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in cityList" :key="key">{{ item }}</a-select-option>
        </a-select>
        <a-select class="address-select" v-model="countyObj" placeholder="区" @change="onCountyChange" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in countyList" :key="key">{{ item }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <form-title text="软件技术特点" />

      <a-form-model-item label="开发硬件环境" prop="developHardware.data">
        <a-input v-model="formData.developHardware.data" type="textarea" @focus="onFocus('developHardware')" @blur="onBlur('developHardware')" :disabled="isDisabled('developHardware')" placeholder="请输入开发登记软件的计算机硬件和专用设备，  如：PC电脑内存：3GBDDR48GCPU:四核3.5GHz硬盘：100G 显卡： 支持GeForceGTX 950 2G" />
      </a-form-model-item>
      <a-form-model-item label="运行硬件环境" prop="productHardware.data">
        <a-input v-model="formData.productHardware.data" type="textarea" @focus="onFocus('productHardware')" @blur="onBlur('productHardware')" :disabled="isDisabled('productHardware')" placeholder="请输入运行登记软件的计算机硬件和专用设备，  如：CPU：2.1GHZ及以上内存：4G及以上存储空间：88GB" />
      </a-form-model-item>

      <a-form-model-item label="开发操作系统" prop="developOs.data">
        <a-input v-model="formData.developOs.data" @focus="onFocus('developOs')" @blur="onBlur('developOs')" :disabled="isDisabled('developOs')" placeholder="请输入开发软件的操作系统，如：Windows10企业版" />
      </a-form-model-item>

      <a-form-model-item label="软件开发环境" prop="developTools.data">
        <a-input v-model="formData.developTools.data" @focus="onFocus('developTools')" @blur="onBlur('developTools')" :disabled="isDisabled('developTools')" placeholder="请输入软件开发环境/开发工具，如：MingW开发工具：VisualStudio2019" />
      </a-form-model-item>
      <a-form-model-item label="软件运行平台" prop="operatingPlatform.data">
        <a-input v-model="formData.operatingPlatform.data" @focus="onFocus('operatingPlatform')" @blur="onBlur('operatingPlatform')" :disabled="isDisabled('operatingPlatform')" placeholder="请输入软件运行平台,如：WindowsXP操作系统及以上" />
      </a-form-model-item>
      <a-form-model-item label="软件支撑环境" prop="supportingEnv.data">
        <a-input v-model="formData.supportingEnv.data" @focus="onFocus('supportingEnv')" @blur="onBlur('supportingEnv')" :disabled="isDisabled('supportingEnv')" placeholder="请输入软件运行支撑环境/支持软件，如：Microsoft.NET1.0" />
      </a-form-model-item>
      <a-form-model-item label="编程语言" prop="programmingLanguage.data">
        <a-input v-model="formData.programmingLanguage.data" @focus="onFocus('programmingLanguage')" @blur="onBlur('programmingLanguage')" :disabled="isDisabled('programmingLanguage')" placeholder="请输入编程语言及版本号,如：C#" />
      </a-form-model-item>
      <a-form-model-item label="源程序量" prop="sourceCodeCount.data">
        <a-input v-model="formData.sourceCodeCount.data" @focus="onFocus('sourceCodeCount')" @blur="onBlur('sourceCodeCount')" :disabled="isDisabled('sourceCodeCount')" placeholder="请输入登记软件源程序的总行数或总条数，如：1000行" />
      </a-form-model-item>

      <a-form-model-item label="开发目的" prop="developPurpose.data">
        <a-input style="width: 750px" :suffix="developPurposeCount" :maxLength="30" v-model="formData.developPurpose.data" @focus="onFocus('developPurpose')" @blur="onBlur('developPurpose')" :disabled="isDisabled('developPurpose')" placeholder="请输入开发目的，如：为了方便用户进行XXX工作。" />
      </a-form-model-item>

      <a-form-model-item label="面向领域/行业" prop="fieldOriented.data">
        <a-input v-model="formData.fieldOriented.data" @focus="onFocus('fieldOriented')" @blur="onBlur('fieldOriented')" :disabled="isDisabled('fieldOriented')" placeholder="请输入面向领域/行业，如：面向XXX行业。" />
      </a-form-model-item>

      <a-form-model-item prop="attributes.data" :colon="false">
        <span slot="label">软件属性: <span>(可选三项)</span> </span>
        <checkbox-group v-model="formData.attributes.data" @change="onBlur('attributes')"></checkbox-group>
      </a-form-model-item>

      <a-form-model-item class="form-item-count" label="软件主要功能" prop="primaryFunction.data">
        <a-input v-model="formData.primaryFunction.data" type="textarea" :maxLength="150" @input="onTextarea($event, 'primaryFunction')" @focus="onFocus('primaryFunction')" @blur="onBlur('primaryFunction')" :disabled="isDisabled('primaryFunction')" placeholder="请输入软件的主要功能" />
        <span class="count"> {{ primaryFunctionCount }} /150</span>
      </a-form-model-item>

      <a-form-model-item class="form-item-count" label="软件技术特点" prop="technicalFeature.data">
        <a-input v-model="formData.technicalFeature.data" type="textarea" :maxLength="150" @input="onTextarea($event, 'technicalFeature')" @focus="onFocus('technicalFeature')" @blur="onBlur('technicalFeature')" :disabled="isDisabled('technicalFeature')" placeholder="请输入软件技术特点" />
        <span class="count"> {{ technicalFeatureCount }} /150</span>
      </a-form-model-item>

      <form-title text="著作权人信息" />

      <a-form-model-item prop="authors.data" :wrapper-col="{ span: 24 }">
        <a-table v-if="dataSource.length" :rowKey="(record) => record.uuid" :columns="columns" :data-source="dataSource" :pagination="false" bordered size="middle">
          <!-- 类型 -->
          <template v-slot:category="text">
            <p class="table-category">{{ text }}</p>
          </template>
          <!-- 纳税号/身份证号 -->
          <template v-slot:socialCreditCode="text, record">
            <p>{{ record.socialCreditCode || record.idCard }}</p>
          </template>
          <!-- 操作 -->
          <template v-slot:action="text, record">
            <a href="javascript:;" @click="onEdit(record)" :disabled="isDisabled('authors')">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm v-if="dataSource.length" title="确认删除吗?" @confirm="() => onDelete(record)">
              <a href="javascript:;" :disabled="isDisabled('authors')">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <a-row style="margin-top: 20px"> <a-button type="primary" icon="plus" @click="onClickTableBtn" :disabled="isDisabled('authors')">添加著作权人</a-button></a-row>
      </a-form-model-item>

      <form-title text="联系人信息" />

      <a-form-model-item label="联系人" prop="contactPerson.data">
        <a-input v-model="formData.contactPerson.data" @focus="onFocus('contactPerson')" @blur="onBlur('contactPerson')" :disabled="isDisabled('contactPerson')" placeholder="请输入联系人姓名" />
      </a-form-model-item>

      <a-form-model-item class="address-wrapper" label="邮寄地址" prop="postalAddress.data">
        <a-select class="address-select" v-model="provinceObj2" placeholder="省" @change="onProvinceChange2" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in provinceList" :key="key" :label="item">{{ item }}</a-select-option>
        </a-select>
        <a-select class="address-select" v-model="cityObj2" placeholder="市" @change="onCityChange2" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in cityList2" :key="key">{{ item }}</a-select-option>
        </a-select>
        <a-select class="address-select" v-model="countyObj2" placeholder="区" @change="onCountyChange2" labelInValue :getPopupContainer="(triggerNode) => triggerNode.parentNode">
          <a-select-option :value="key" v-for="(item, key) in countyList2" :key="key">{{ item }}</a-select-option>
        </a-select>
        <a-form-model-item style="display: inline-block; width: 294px; min-width: 170px; margin: 0" prop="postalAddressPrecise.data">
          <a-input style="width: 294px" v-model="formData.postalAddressPrecise.data" @focus="onFocus('postalAddressPrecise')" @blur="onBlur('postalAddressPrecise')" :disabled="isDisabled('postalAddressPrecise')" placeholder="请输入准确的邮寄地址" />
        </a-form-model-item>
      </a-form-model-item>

      <a-form-model-item label="邮政编码" prop="postalCode.data">
        <a-input v-model="formData.postalCode.data" @focus="onFocus('postalCode')" @blur="onBlur('postalCode')" :disabled="isDisabled('postalCode')" placeholder="请输入所在行政区县的邮政编码" />
      </a-form-model-item>

      <a-form-model-item label="联系电话" prop="contactPhone.data">
        <a-input v-model="formData.contactPhone.data" @focus="onFocus('contactPhone')" @blur="onBlur('contactPhone')" :disabled="isDisabled('contactPhone')" placeholder="请输入11位手机号码" />
      </a-form-model-item>

      <a-form-model-item label="电子邮箱" prop="contactEmail.data">
        <a-input v-model="formData.contactEmail.data" @focus="onFocus('contactEmail')" @blur="onBlur('contactEmail')" :disabled="isDisabled('contactEmail')" placeholder="请输入常用邮箱，重要官文会通过邮件通知" />
      </a-form-model-item>

      <a-form-model-item label="座机电话">
        <a-input v-model="formData.contactLanline.data" @focus="onFocus('contactLanline')" @blur="onBlur('contactLanline')" :disabled="isDisabled('contactLanline')" placeholder="请输入区号-座机号码" />
      </a-form-model-item>

      <form-title text="软件鉴别材料" />

      <a-form-model-item label="软件说明文档" prop="softwareDocument.data">
        <upload-file-btn
          v-model="formData.softwareDocument.data"
          @onSuccess="
            (data) => {
              onSuccess(data, 'softwareDocument')
            }
          "
        />
        <div class="tip cr-fs-sm">
          <svg-icon class="tip-icon" icon-class="tip"></svg-icon>
          <span>
            <p>1.需提供word版的软件详细使用说明文档或设计开发文档，图文结合的形式不少于15页，文档每页不少于2张图。</p>
            <p style="margin-top: 6px">2.使用说明须含有详细的登录界面、操作步骤截图及文字描述。设计说明须含有详细的软件结构图、各个功能的流程图、逻辑框图，介绍软件总体、接口设计，模块名称功能， 函数名称功能，算法，数据结构、数据字典、运行设计等内容。</p>
          </span>
        </div>
      </a-form-model-item>

      <a-form-model-item class="model-item" label="说明书中是否含有英文" prop="includingEnglish.data">
        <a-radio-group name="radioGroup" v-model="formData.includingEnglish.data" @change="onBlur('includingEnglish')">
          <a-radio value="1"> 是 </a-radio>
          <a-radio value="2"> 否 </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="软件源代码" prop="scoreCode.data">
        <upload-file-btn
          v-model="formData.scoreCode.data"
          @onSuccess="
            (data) => {
              onSuccess(data, 'scoreCode')
            }
          "
        />
        <div class="tip cr-fs-sm">
          <svg-icon class="tip-icon" icon-class="tip"></svg-icon>
          <span>
            <p>应提交前、后各连续30-40页（共60-80页），每页不少于50行，总行数不少于3000行；不包含符号，不能出现乱码，最后一页应是程序的结束页；不足60页的，应当全部提交。</p>
          </span>
        </div>
      </a-form-model-item>
      <!-- 其他材料 -->
      <template v-if="showOther">
        <form-title text="其他材料" />
        <a-form-model-item label="合作开发协议" prop="cooperativeAgreement.data" v-if="dataSource.length > 1">
          <upload-file-btn
            v-model="formData.cooperativeAgreement.data"
            @onSuccess="
              (data) => {
                onSuccess(data, 'cooperativeAgreement')
              }
            "
          />
          <a :href="link7" class="download">下载模板</a>
        </a-form-model-item>
        <a-form-model-item label="名称英文解释" prop="nameExplanation.data" v-if="hasEng">
          <upload-file-btn
            v-model="formData.nameExplanation.data"
            @onSuccess="
              (data) => {
                onSuccess(data, 'nameExplanation')
              }
            "
          />
          <a :href="link10" class="download">下载模板</a>
        </a-form-model-item>
        <a-form-model-item label="说明书英文解释" prop="manualExplanation.data" v-if="formData.includingEnglish.data == '1'">
          <upload-file-btn
            v-model="formData.manualExplanation.data"
            @onSuccess="
              (data) => {
                onSuccess(data, 'manualExplanation')
              }
            "
          />
          <a :href="link11" class="download">下载模板</a>
        </a-form-model-item>
      </template>
    </a-form-model>
    <!-- 来源分享 -->
    <a-row v-if="from === 'share'" class="footer" :gutter="10">
      <a-col>
        <a-button @click="onSaveCase" type="primary">保存案件信息</a-button>
      </a-col>
    </a-row>
    <a-row v-else class="footer" :gutter="10">
      <a-col>
        <a-button @click="onPay" v-if="transState == 0" style="background: #ff6d33; color: #fff; border: none">立即支付</a-button>
      </a-col>
      <a-col>
        <a-button @click="onSaveCase">保存案件信息</a-button>
      </a-col>
      <a-col>
        <a-button type="primary" @click="onShare">分享客户填写</a-button>
      </a-col>
      <a-col>
        <a-button @click="onSubmit" type="primary" v-if="transState != 0">提交案件</a-button>
      </a-col>
    </a-row>

    <template v-if="ownerVisible">
      <owner-info :ownerVisible.sync="ownerVisible" @saveData="saveData" @updateData="updateData"></owner-info>
    </template>
  </div>
</template>

<script>
import CheckboxGroup from './checkboxGroup'
import FormTitle from './formTitle'
import OwnerInfo from './ownerInfo'
import UploadFileBtn from '@/components/common/UploadFileBtn'
import { province_list, city_list, county_list } from './address'
import { rules, columns } from './baseForm'
import { validAlphabets } from '@/utils/validate'
import { link7, link10, link11 } from './templateUrl'

export default {
  name: 'BaseForm',
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    from: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    transState: Number
  },
  data() {
    return {
      link7, // 合作开发协议
      link10, // 英文解释说明-名称含英文
      link11, // 英文解释说明
      provinceList: province_list,
      cityList: {},
      countyList: {},
      cityList2: {},
      countyList2: {},
      provinceObj: undefined, // 当前选中省
      cityObj: undefined,
      countyObj: undefined,
      provinceObj2: undefined, // 当前选中省
      cityObj2: undefined,
      countyObj2: undefined,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      primaryFunctionCount: 0, // 输入字数个数
      technicalFeatureCount: 0, // 输入字数个数
      developPurposeCount: '0/30', // 输入字数个数
      rules,
      columns,
      dataSource: [],
      ownerVisible: false,
      test: ''
    }
  },
  methods: {
    onRadioChange() {
      console.log('onRadioChange')
    },

    onPay() {
      this.$emit('onPay')
    },

    // 文件上传成功
    onSuccess(data, target) {
      this.$emit('onDataChange', { target, data })
    },
    // 更新表格数据
    updateData(data) {
      let uuid = data.uuid
      let dataSource = this.dataSource
      dataSource.forEach((item) => {
        if (item.uuid === uuid) {
          Object.assign(item, data)
        }
      })
      this.$emit('onDataChange', { target: 'authors', data: dataSource })
    },
    // 保存表格数据
    saveData(data) {
      this.dataSource.push(data)
      this.$emit('onDataChange', { target: 'authors', data: this.dataSource })
      this.$nextTick(() => {
        this.$refs.form.clearValidate('authors.data')
      })
    },
    onTextarea(e, type) {
      if (type === 'primaryFunction') {
        this.primaryFunctionCount = e.target.value.length
      } else if (type === 'technicalFeature') {
        this.technicalFeatureCount = e.target.value.length
      }
    },
    onProvinceChange({ key }) {
      this.cityList = this._calcCityList(key)
      this.cityObj = undefined
      this.countyObj = undefined
      this.countyList = {}
    },
    onProvinceChange2({ key }) {
      this.cityList2 = this._calcCityList(key)
      this.cityObj2 = undefined
      this.countyObj2 = undefined
      this.countyList2 = {}
    },
    onCityChange({ key }) {
      this.countyList = this._calcCountyList(key)
      this.countyObj = undefined
    },
    onCityChange2({ key }) {
      this.countyList2 = this._calcCountyList(key)
      this.countyObj2 = undefined
    },
    onCountyChange() {
      const address = [this.provinceObj, this.cityObj, this.countyObj]
      this.$emit('onDataChange', { target: 'firstPublishAddress', data: address })
      this.$nextTick(() => {
        this.$refs.form.clearValidate('firstPublishAddress.data')
      })
    },
    onCountyChange2() {
      const address = [this.provinceObj2, this.cityObj2, this.countyObj2]
      this.$emit('onDataChange', { target: 'postalAddress', data: address })
      this.$nextTick(() => {
        this.$refs.form.clearValidate('postalAddress.data')
      })
    },
    _calcCityList(code) {
      let res = {}
      let ab = code.slice(0, 2) // 前两位
      for (const key in city_list) {
        if (Object.hasOwnProperty.call(city_list, key)) {
          if (key.startsWith(ab)) {
            res[key] = city_list[key]
          }
        }
      }
      return res
    },
    _calcCountyList(code) {
      let res = {}
      let abcd = code.slice(0, 4) // 前四位
      for (const key in county_list) {
        if (Object.hasOwnProperty.call(county_list, key)) {
          if (key.startsWith(abcd)) {
            res[key] = county_list[key]
          }
        }
      }
      return res
    },
    onSubmit() {
      this.validateForm()
    },
    // 保存案件
    onSaveCase() {
      if (this.from == 'share') {
        this.$emit('saveCase', false)
      } else {
        // 当保存案件时提示案件信息保存成功、检测所有必填项已填写全且已付款时，modal提示
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.$emit('saveCase', false)
          } else {
            this.$emit('saveCase', true)
          }
          this.$refs.form.clearValidate()
        })
      }
    },
    onShare() {
      this.$emit('onShare')
    },
    onClickTableBtn() {
      sessionStorage.removeItem('currentFormData')
      this.ownerVisible = true
    },
    onEdit(record) {
      sessionStorage.setItem('currentFormData', JSON.stringify(record))
      this.ownerVisible = true
    },
    onDelete(record) {
      this.dataSource = this.removeArray(this.dataSource, record)
      this.$emit('onDataChange', { target: 'authors', data: this.dataSource })
    },

    removeArray(_arr, _obj) {
      let length = _arr.length
      for (var i = 0; i < length; i++) {
        if (_arr[i] == _obj) {
          if (i == 0) {
            _arr.shift() //删除并返回数组的第一个元素
            return _arr
          } else if (i == length - 1) {
            _arr.pop() //删除并返回数组的最后一个元素
            return _arr
          } else {
            _arr.splice(i, 1) //删除下标为i的元素
            return _arr
          }
        }
      }
    },
    onFocus(key) {
      this.$emit('onFocus', key)
    },
    onBlur(key) {
      this.$emit('onBlur', key)
    },
    validateForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$nextTick(() => {
            let errorEl = this.$refs.form.$el.querySelector('.has-error')
            errorEl && errorEl.scrollIntoView({ block: 'center', behavior: 'smooth' })
          })
        } else {
          // 校验通过，提交表单
          this.$emit('onSubmit')
        }
      })
    },
    isDisabled(key) {
      if (this.formData[key].focusUser == this.token) {
        // 是当前用户锁住的输入框，就不禁用
        return false
      }
      if (this.formData[key].enableAt == '1') {
        return true
      }
    }
  },
  watch: {
    'formData.firstPublishAddress.data'(val) {
      if (val) {
        let arr = JSON.parse(val)
        this.provinceObj = arr[0]
        this.cityObj = arr[1]
        this.countyObj = arr[2]
        this.cityList = this._calcCityList(arr[1].key)
        this.countyList = this._calcCountyList(arr[2].key)
      }
    },
    'formData.postalAddress.data'(val) {
      if (val) {
        let arr = JSON.parse(val)
        this.provinceObj2 = arr[0]
        this.cityObj2 = arr[1]
        this.countyObj2 = arr[2]
        this.cityList2 = this._calcCityList(arr[1].key)
        this.countyList2 = this._calcCountyList(arr[2].key)
      }
    },
    'formData.primaryFunction.data'(val) {
      if (val) {
        this.primaryFunctionCount = val.length
      }
    },
    'formData.technicalFeature.data'(val) {
      if (val) {
        this.technicalFeatureCount = val.length
      }
    },
    'formData.developPurpose.data'(val) {
      if (val) {
        this.developPurposeCount = `${val.length}/30`
      } else {
        this.developPurposeCount = `0/30`
      }
    },
    'formData.authors.data'(val) {
      if (val && Array.isArray(JSON.parse(val))) {
        this.dataSource = JSON.parse(val)
      }
    },
    ownerVisible(val) {
      if (val) {
        this.$emit('onFocus', 'authors')
      } else {
        this.$emit('enable', 'authors')
      }
    }
  },
  computed: {
    hasEng() {
      let fullName = this.formData.fullName.data
      // 全称仅有 APP 不算有英文
      if (fullName.includes('APP')) {
        fullName = fullName.replace('APP', '')
      }
      return validAlphabets(fullName)
    },
    // 是否展示其他材料
    showOther() {
      return this.dataSource.length > 1 || this.hasEng || this.formData.includingEnglish.data == '1'
    }
  },
  components: {
    FormTitle,
    OwnerInfo,
    UploadFileBtn,
    CheckboxGroup
  }
}
</script>

<style lang="less" scoped>
.form-container {
  .tip {
    display: flex;
    margin-top: 4px;
    .tip-icon {
      font-size: 16px;
      vertical-align: middle;
      margin-right: 4px;
      flex-shrink: 0;
      margin-top: 2px;
      &.tip-icon-color {
        color: #eeaa00;
      }
    }
    span {
      line-height: 20px;
    }
  }
  .address-select {
    width: 142px;
    margin-right: 10px;
    /deep/ .ant-select-selection {
      border-radius: 2px;
    }
  }

  .form-item-count {
    position: relative;
    .count {
      position: absolute;
      bottom: 0;
      right: 10px;
      font-size: 14px;
      line-height: 14px;
      color: #ccc;
    }
  }
  .download {
    margin-left: 14px;
  }
  .table-category {
    height: 22px;
    line-height: 22px;
    color: #1664ff;
    background: #e7efff;
    display: inline-block;
    padding: 0 16px;
    border-radius: 2px;
  }

  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 60px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    background: #fff;
    z-index: 10;
  }
  /deep/ .ant-input {
    border-radius: 3px !important;
    width: 750px;
  }
  .date-picker {
    /deep/ .ant-input {
      width: 370px;
    }
  }
}
/deep/ .ant-radio-button-wrapper {
  width: 160px;
  text-align: center;
  border-radius: 2px 0 0 2px;
}
/deep/ .ant-input-suffix {
  color: #cccccc !important;
}
/deep/ .ant-form-item {
  margin-bottom: 16px;
}

/deep/ .ant-btn {
  border-radius: 2px !important;
}

/deep/.ant-form-item-label {
  > label::before {
    display: inline-block;
    margin-right: 4px;
    width: 7px;
    content: '';
  }
}
/deep/.ant-form-item-required::before {
  content: '*' !important;
  color: @cr-text-red;
}

.model-item {
  /deep/ .ant-form-item-label {
    width: 180px !important;
  }
}
/deep/ .ant-form-item-label {
  width: 150px !important;
}
</style>
